import BaseForm from '../base';
export class TanksPanelForm extends BaseForm {
    constructor(...args) {
        super(...args);
    }
}
export default {
    components: []
};
